import { useEffect, useState, useCallback } from "react";
import { graphqlRequest } from "../api/client";
import { APIsQueryResponse, API } from "../types";
import { GET_APIS } from "../api/queries/queries";

export const useApis = () => {
  const [apis, setApis] = useState<API[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchApis = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data: APIsQueryResponse = await graphqlRequest<APIsQueryResponse>(
        GET_APIS
      );

      // Map GraphQL response correctly
      setApis(data?.data?.apis ?? []); 
    } catch (err: any) {
      console.error(err);
      setError(err.message || "Failed to fetch APIs");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchApis();
  }, [fetchApis]);

  const refresh = () => fetchApis();

  return { apis, loading, error, refresh };
};
